export const TABLE_TRANSLATION_NAMESPACE = "table2";

export const TABLE_FOOTER_TK = "TABLE_FOOTER_TK";
export const TABLE_ACTION_TK = "TABLE_ACTION_TK";
